import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../../comum/Titulo';
import buscarUsuarios from '../../../actions/usuario/buscarUsuariosPlataformas';
import excluirUsuario from '../../../actions/usuario/exclurUsuario';
import {alterouFiltro, alterouPagina} from '../../../util/filtros';
import {PERFIL_ADMIN} from '../../../security/securityContext';
import Autorizacao from '../../../security/Autorizacao';
import ModalCadastrarUsuarioPlataforma from './ModalCadastrarUsuarioPlataforma';
import {alterouEmpresa} from '../../../actions/empresa/alterarEmpresaSelecionada';
import PaginacaoUsuarios from '../PaginacaoUsuarios';
import BotoesPaginacaoUsuarios from '../BotoesPaginacaoUsuarios';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import determinarPaginaAtual from '../../../actions/usuario/determinarPaginaAtualUsuarios';
import alterarRegistrosPorPagina from '../../../actions/usuario/alterarRegistrosPorPaginaUsuarios';
import PainelFiltrosUsuariosPlataformas from './PainelFiltrosUsuariosPlataformas';
import bloquearUsuario from '../../../actions/usuario/bloquearUsuario';
import desbloquearUsuario from '../../../actions/usuario/desbloquearUsuario';
import buscarPlataformas from '../../../actions/empresa/buscarPlataformas';
import UsuarioPlataforma from './UsuarioPlataforma';
import selecionarUsuario from '../../../actions/usuario/selecionarUsuario';
import limparUsuarios from '../../../actions/usuario/limparUsuarios';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import {URL} from '../../../util/ambienteActions';
import { montarURLFiltro } from '../../../util/filtros';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Nome</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">CPF</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Email</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Telefone</div>
            <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Plataforma</div>
            <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Data de criação</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarUsuariosPlataforma extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.buscarUsuarios = this.buscarUsuarios.bind(this);
        this.bloquearDesbloquear = this.bloquearDesbloquear.bind(this);
        this.state = {
            usuarioSelecionado: null,
            textoFiltro: null,
        };
    }

    componentDidMount() {
        this.props.limparUsuarios();
        this.props.buscarPlataformas();
        this.buscarUsuarios();
    }


    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarUsuarios()
        }
    }

    buscarUsuarios() {
        this.props.buscarUsuarios(this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'idUsuario', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'email', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'perfil', '');
    }

    bloquearDesbloquear() {
        if (this.props.usuarioSelecionado.bloqueado) {
            this.props.desbloquearUsuario(this.props.usuarioSelecionado.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuarios();
                    }
                })
        } else {
            this.props.bloquearUsuario(this.props.usuarioSelecionado.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuarios();
                    }
                })
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuario');
        this.setState({perfisSelecionados: []})
        this.props.limparPerfis()
        this.buscarUsuarios();
    }

    async downloadParte(url, size, from) {
        const urlFiltros = montarURLFiltro(this.props.filtrosAdicionados);

        let urlReq = `${url}?size=${size}&from=${from}&${urlFiltros}`;
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);

        return retorno.data;
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');
        
        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'Lista de Usuários Plataforma.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarListaUsuarios() {
        let arquivo = 'Nome;CPF;E-mail;Telefone;Plataforma;Data de Criação;Situação\n';
        let url = `${URL}/usuarios/plataforma-web`;

        let count = 0;
        let from = 1;
        let size = 10000;

        let qtd = this.props.total;
        let totalParticoes = Math.ceil(qtd / 10000);

        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, size, from);

            arquivo = `${arquivo}${retorno.usuarios.map(it => {

                const situacao = it.rolesName.length ? 'Ativo' : 'Inativo';
                const telefone = it.telefone ? it.telefone.replace(/\D/g,'').replace(/^(\d{2})(\d)/g,'($1) $2').replace(/(\d)(\d{4})$/,'$1-$2') : 'Sem telefone';

                let valor = `${it.nome};${it.cpfCnpj};${it.email};"${telefone}";"${it.plataforma}";"${it.dataCriacao}";"${situacao}"`

                return valor;

            }).join('\n')}\n`;

            from += 1;
            count += 1;

            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoes() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="text-right">
                        <button className="btn btn-laranja mr-2"
                                onClick={() => this.exportarListaUsuarios()}>
                            Exportar Lista
                        </button>
                        <button data-toggle="modal" data-target="#modalCadastrarUsuarioPlataforma"
                                className="btn btn-laranja" onClick={() => this.props.selecionarUsuario({})}>
                            Novo Usuário
                        </button>
                    </div>
                </div>
            </div>)
    }

    exibirTabelaUsuarios() {
        if (this.props.usuarios && this.props.usuarios.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoUsuarios}
                                       BotoesPaginacao={BotoesPaginacaoUsuarios}>
                    <CabecalhoTabela/>
                    <div className="lista-table">
                        {this.exibirUsuarios()}
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum usuário cadastrado para a empresa</div>;
    }

    exibirUsuarios() {
        return this.props.usuarios
            .map((usuario) => <UsuarioPlataforma key={usuario.id} usuario={usuario}
                                                 buscarUsuarios={this.buscarUsuarios}/>)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Usuários (Plataformas)" urlRetorno="/menu-usuario"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                              <PainelFiltrosUsuariosPlataformas/>
                            </div>
                            {this.exibirBotoes()}
                            {this.exibirTabelaUsuarios()}
                        </div>
                    </div>
                    <ModalCadastrarUsuarioPlataforma buscarUsuarios={this.buscarUsuarios}/>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        usuarios: state.usuarios.usuarios,
        total: state.usuarios.total,
        plataformas: state.plataformas,
        usuarioSelecionado: state.usuarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        perfisSelecionados: state.perfisSelecionados,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosUsuarios
    });


export default connect(mapStateToProps, {
    buscarPlataformas,
    buscarUsuarios,
    excluirUsuario,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    desbloquearUsuario,
    bloquearUsuario,
    selecionarUsuario,
    limparUsuarios
})(reduxForm({
    form: 'formularioCadastroUsuario'
})(PainelGerenciarUsuariosPlataforma))
